// extracted by mini-css-extract-plugin
export var activeDot = "_2x-c";
export var buttonContainer = "_2x-9";
export var channelButton = "_2x-a";
export var clickable = "_2x-d";
export var content = "_2x-0";
export var contentFull = "_2x-2";
export var contentThird = "_2x-1";
export var contentWrapper = "_2x-7";
export var description = "_2x-5";
export var heightShort = "_2x-f";
export var image = "_2x-3";
export var imageContainer = "_2x-4";
export var selectButton = "_2x-e";
export var spinnerContainer = "_2x-b";
export var titleContent = "_2x-8";
export var titleWrapper = "_2x-6";